import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface QuickRegistrationProps {
  onQuickRegister: () => void;
  label?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

export function QuickRegistration({
  onQuickRegister,
  label = 'Register Now',
  isLoading = false,
  disabled = false,
}: QuickRegistrationProps) {
  return (
    <div className="flex justify-center">
      <Button
        onClick={onQuickRegister}
        size="lg"
        disabled={disabled || isLoading}
        className="w-full md:w-auto text-lg px-8 py-6 hidden md:flex shadow-md"
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            Registering...
          </>
        ) : (
          label
        )}
      </Button>
    </div>
  );
}
